var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_36506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "#FFF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.503 879.498C126.503 879.498 121.103 879.398 117.203 871.298L120.003 870.498L119.303 866.298C119.303 866.298 126.603 863.698 129.903 870.098C129.903 870.098 128.303 863.898 135.803 859.898L136.403 862.598L139.903 859.998C139.903 859.998 145.703 863.998 141.203 871.898C141.203 871.898 149.203 867.698 154.503 876.498L150.703 878.698L153.503 881.698C153.503 881.698 150.903 886.998 142.903 883.898C142.903 883.898 146.903 890.898 143.603 895.298L141.003 892.898L139.403 896.698C139.403 896.698 134.403 893.298 133.603 885.998C133.603 885.998 131.503 892.098 123.803 893.898L124.603 889.798L120.403 890.998C120.403 891.098 117.703 882.798 126.503 879.498Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.906 872.597L122.506 871.397L121.506 868.197C121.506 868.197 128.406 868.697 131.106 872.797C131.106 872.797 131.106 865.797 134.706 863.097L135.706 865.397L139.306 862.797C139.306 862.797 141.606 866.897 139.506 873.397C139.506 873.397 146.506 870.397 150.706 874.297L147.306 876.897L150.306 880.997C150.306 880.997 144.506 882.997 140.906 881.097C140.906 881.097 145.506 888.197 143.206 891.697L140.706 889.097L138.606 893.297C138.606 893.297 133.806 888.997 135.106 882.697C135.106 882.697 132.606 888.297 127.006 890.297L127.406 887.497H122.206C122.206 887.497 123.606 882.797 129.906 879.197C129.706 879.297 121.806 876.697 119.906 872.597Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.705 878.297C133.705 878.297 132.105 877.597 132.505 875.597C132.505 875.597 134.005 874.997 135.105 876.397C135.105 876.397 135.805 874.197 137.505 874.497C137.505 874.497 138.405 876.397 137.805 877.497C137.805 877.497 139.305 877.297 139.405 878.897C139.405 878.897 138.705 880.597 137.205 879.897C137.205 879.897 137.405 881.197 136.105 882.097C136.105 882.097 134.905 881.197 135.005 880.097C135.005 880.097 134.105 881.297 132.605 880.597C132.705 880.397 131.305 879.297 133.705 878.297Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.402 944.699C190.402 944.699 194.602 942.999 200.202 948.099L198.302 949.599L200.102 952.599C200.102 952.599 195.302 956.799 190.702 953.099C190.702 953.099 193.902 957.299 189.302 962.899L187.902 960.999L186.002 964.099C186.002 964.099 180.302 962.799 181.302 955.299C181.302 955.299 176.402 961.099 169.502 955.899L171.702 952.899L168.602 951.499C168.602 951.499 168.902 946.499 176.102 946.499C176.102 946.499 170.702 942.299 172.002 937.899L174.802 938.899V935.499C174.802 935.499 179.702 936.499 182.702 941.999C182.702 941.999 182.402 936.599 187.802 932.699L188.402 936.099L191.302 933.799C191.502 933.799 196.202 939.499 190.402 944.699Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.702 947.998L196.102 949.698L197.902 951.898C197.902 951.898 192.502 953.698 189.002 951.298C189.002 951.298 191.202 956.698 189.202 959.898L187.602 958.498L185.702 961.598C185.702 961.598 182.702 959.098 182.202 953.398C182.202 953.398 177.702 957.898 173.302 956.298L175.102 953.198L171.602 950.998C171.602 950.998 175.502 947.598 178.902 947.998C178.902 947.998 173.102 943.898 173.802 940.498L176.502 941.798L176.802 937.998C176.802 937.998 181.802 939.798 182.902 944.998C182.902 944.998 183.102 939.898 186.702 936.598L187.302 938.798L191.302 937.198C191.302 937.198 191.702 941.398 187.902 946.098C188.102 945.898 194.902 945.498 197.702 947.998Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.202 947.901C185.202 947.901 186.702 948.001 187.002 949.701C187.002 949.701 186.002 950.701 184.802 949.901C184.802 949.901 184.902 951.801 183.502 952.101C183.502 952.101 182.202 950.901 182.302 949.901C182.302 949.901 181.202 950.501 180.602 949.301C180.602 949.301 180.602 947.801 182.002 947.801C182.002 947.801 181.402 946.901 182.202 945.801C182.202 945.801 183.402 946.101 183.702 947.001C183.702 947.001 184.002 945.701 185.502 945.901C185.402 946.001 186.802 946.401 185.202 947.901Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.498 919.997C125.498 919.997 123.798 916.697 124.098 914.097C124.398 911.497 129.098 910.297 129.098 910.297C129.098 910.297 130.498 913.297 130.398 915.797C130.398 918.197 125.498 919.997 125.498 919.997Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.797 921.295C126.797 921.295 129.397 917.795 132.197 918.295C134.997 918.795 135.997 921.195 135.997 921.195C135.997 921.195 134.897 924.095 131.897 923.995C128.897 923.795 126.797 921.295 126.797 921.295Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.198 922.195C125.198 922.195 124.098 923.595 123.898 925.995C123.698 928.295 127.398 930.695 127.398 930.695C127.398 930.695 129.598 928.195 129.698 925.995C129.798 923.795 125.198 922.195 125.198 922.195Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7 921.399C123.7 921.399 124.2 924.399 121.1 925.999C118 927.599 115 926.199 115 926.199C115 926.199 115.8 923.899 117.2 921.999C118.6 920.099 123.7 921.399 123.7 921.399Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.298 919.798C123.298 919.798 119.098 920.798 117.598 919.198C116.198 917.798 116.298 912.798 116.298 912.798C116.298 912.798 120.298 911.598 122.198 913.398C124.098 915.298 123.298 919.798 123.298 919.798Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.701 930.5C224.701 930.5 223.001 927.1 223.301 924.4C223.601 921.7 228.501 920.5 228.501 920.5C228.501 920.5 229.901 923.5 229.801 926.1C229.701 928.7 224.701 930.5 224.701 930.5Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.102 931.8C226.102 931.8 228.802 928.2 231.702 928.7C234.602 929.2 235.502 931.6 235.502 931.6C235.502 931.6 234.402 934.6 231.302 934.5C228.202 934.3 226.102 931.8 226.102 931.8Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.501 932.699C224.501 932.699 223.401 934.199 223.101 936.499C222.901 938.899 226.701 941.299 226.701 941.299C226.701 941.299 228.901 938.699 229.101 936.499C229.201 934.299 224.501 932.699 224.501 932.699Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.902 931.9C222.902 931.9 223.402 935 220.302 936.6C217.202 938.2 214.102 936.8 214.102 936.8C214.102 936.8 214.902 934.4 216.302 932.5C217.702 930.7 222.902 931.9 222.902 931.9Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.498 930.201C222.498 930.201 218.198 931.201 216.698 929.601C215.198 928.001 215.298 923.001 215.298 923.001C215.298 923.001 219.398 921.801 221.398 923.601C223.298 925.701 222.498 930.201 222.498 930.201Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.6 811.501H1742.6H1737.2C1736.5 811.501 1735.8 810.901 1735.8 810.201V808.801C1735.8 808.101 1736.4 807.401 1737.2 807.401H1737.3H1741.7C1743.1 807.401 1744.2 806.401 1744.3 805.101C1744.4 803.701 1743.3 802.501 1741.9 802.501H1723.9C1723.4 802.501 1723.1 801.801 1723.1 800.901V799.401C1723.1 798.501 1723.5 797.801 1723.9 797.801H1725.7C1727.5 797.801 1729.2 796.401 1729.4 794.601C1729.6 792.501 1728 790.801 1725.9 790.801H1709.8C1708.9 790.801 1708.2 791.401 1708.1 792.201C1708 793.201 1708.7 794.001 1709.7 794.001H1715.7C1716.2 794.001 1716.5 794.701 1716.5 795.601V796.401C1716.5 797.301 1716.1 798.001 1715.7 798.001H1654.1C1651.1 798.001 1648.4 800.301 1648.3 803.401C1648.2 806.501 1650.7 809.201 1653.8 809.201H1730.5C1731 809.201 1731.3 809.901 1731.3 810.801V813.001C1731.3 813.901 1730.9 814.601 1730.5 814.601H1707.9C1706.1 814.601 1704.5 815.901 1704.4 817.601C1704.2 819.601 1705.8 821.401 1707.8 821.401H1763.8C1766.6 821.401 1768.9 819.101 1768.8 816.201C1768.8 813.601 1766.4 811.501 1763.6 811.501Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1724.4 915.702H1745.4H1750.8C1751.5 915.702 1752.2 915.102 1752.2 914.402V913.002C1752.2 912.302 1751.6 911.602 1750.8 911.602H1750.7H1746.3C1744.9 911.602 1743.8 910.602 1743.7 909.302C1743.6 907.902 1744.7 906.702 1746.1 906.702H1764.1C1764.6 906.702 1764.9 906.002 1764.9 905.102V903.702C1764.9 902.802 1764.5 902.102 1764.1 902.102H1762.3C1760.5 902.102 1758.8 900.702 1758.6 898.902C1758.4 896.802 1760 895.102 1762.1 895.102H1778.2C1779.1 895.102 1779.8 895.702 1779.9 896.502C1780 897.502 1779.3 898.302 1778.3 898.302H1772.3C1771.8 898.302 1771.5 899.002 1771.5 899.902V900.702C1771.5 901.602 1771.9 902.302 1772.3 902.302H1799.3C1802.3 902.302 1805 904.602 1805.1 907.702C1805.2 910.802 1802.7 913.502 1799.6 913.502H1757.4C1756.9 913.502 1756.6 914.202 1756.6 915.102V917.302C1756.6 918.202 1757 918.902 1757.4 918.902H1758.8C1760.6 918.902 1762.2 920.202 1762.3 921.902C1762.5 923.902 1760.9 925.702 1758.9 925.702H1724.2C1721.4 925.702 1719.1 923.402 1719.2 920.502C1719.2 917.802 1721.6 915.702 1724.4 915.702Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.2 889.799H1582.2H1576.8C1576.1 889.799 1575.4 889.199 1575.4 888.499V887.099C1575.4 886.399 1576 885.699 1576.8 885.699H1576.9H1581.3C1582.7 885.699 1583.8 884.699 1583.9 883.399C1584 881.999 1582.9 880.799 1581.5 880.799H1563.5C1563 880.799 1562.7 880.099 1562.7 879.199V877.799C1562.7 876.899 1563.1 876.199 1563.5 876.199H1565.3C1567.1 876.199 1568.8 874.799 1569 872.999C1569.2 870.899 1567.6 869.199 1565.5 869.199H1549.4C1548.5 869.199 1547.8 869.799 1547.7 870.599C1547.6 871.599 1548.3 872.399 1549.3 872.399H1555.3C1555.8 872.399 1556.1 873.099 1556.1 873.999V874.799C1556.1 875.699 1555.7 876.399 1555.3 876.399H1529.5C1526.5 876.399 1523.8 878.699 1523.7 881.799C1523.6 884.899 1526.1 887.599 1529.2 887.599H1570.2C1570.7 887.599 1571 888.299 1571 889.199V891.399C1571 892.299 1570.6 892.999 1570.2 892.999H1568.8C1567 892.999 1565.4 894.299 1565.3 895.999C1565.1 897.999 1566.7 899.799 1568.7 899.799H1603.4C1606.2 899.799 1608.5 897.499 1608.4 894.599C1608.4 891.799 1606 889.799 1603.2 889.799Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.2 944.202H1566.4C1564.3 944.202 1562.6 942.502 1562.6 940.402V938.702C1562.6 936.602 1564.3 934.902 1566.4 934.902H1585.2C1587.3 934.902 1589 936.602 1589 938.702V940.402C1589 942.502 1587.3 944.202 1585.2 944.202Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.2 810.101H1561.9C1559.8 810.101 1558.1 808.401 1558.1 806.301V804.601C1558.1 802.501 1559.8 800.801 1561.9 800.801H1575.2C1577.3 800.801 1579 802.501 1579 804.601V806.301C1578.9 808.401 1577.2 810.101 1575.2 810.101Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.5 860.202H1777.3C1775.2 860.202 1773.5 858.502 1773.5 856.402V854.702C1773.5 852.602 1775.2 850.902 1777.3 850.902H1790.6C1792.7 850.902 1794.4 852.602 1794.4 854.702V856.402C1794.3 858.502 1792.6 860.202 1790.5 860.202Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.89 892.602C1729.89 892.602 1757.89 895.202 1751.39 867.102C1751.39 867.102 1758.59 871.602 1759.59 877.402C1760.59 883.202 1756.09 888.502 1756.09 888.502C1756.09 888.502 1761.59 883.002 1762.29 885.502C1762.89 888.102 1755.29 894.202 1755.29 894.202C1755.29 894.202 1761.59 894.802 1758.39 899.002C1755.19 903.202 1746.89 900.402 1746.89 900.402C1746.89 900.402 1753.89 903.502 1749.69 906.802C1745.49 910.102 1736.69 909.802 1728.49 901.802",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.89 897.102C1744.89 897.102 1746.99 897.602 1749.89 897.302",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.39 893.2C1748.39 893.2 1750.99 893.2 1753.09 892.5",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.59 902.301C1737.59 902.301 1741.79 905.301 1744.39 905.101",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.49 900.203C1742.49 900.203 1745.49 902.303 1746.49 902.003",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.09 901.199L1601.49 911.799C1601.49 911.799 1597.59 909.699 1592.69 909.099C1586.89 908.399 1582.49 914.199 1584.79 919.599L1586.89 924.499C1586.89 924.499 1598.69 941.099 1649.09 911.499",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.79 902.499L1620.09 901.199L1602.39 911.299C1602.59 913.799 1603.79 916.399 1607.59 917.099C1613.49 917.999 1622.89 908.899 1623.79 902.499Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1597.99 920.001C1597.99 920.001 1590.89 919.201 1589.89 926.101",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.9 916.399C1593.9 916.399 1586.8 915.599 1585.8 922.499",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.59 930.898C1681.59 930.898 1682.19 948.398 1705.79 945.698C1705.79 945.698 1702.09 955.898 1710.19 956.298C1710.19 956.298 1727.29 948.698 1720.69 936.098C1719.79 934.298 1705.69 931.898 1706.09 911.898",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714.6 944C1714.6 944 1712.5 949.5 1717.9 951.6",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.79 946.598C1710.79 946.598 1708.69 952.098 1714.09 954.198",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.9 853C1687.9 853 1690.1 861 1701.3 866.3C1715.8 873.2 1739.4 880.2 1731.6 909.6C1718.3 959.3 1583.2 928.7 1629.6 869.3L1687.9 853Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.3 866.201C1700.3 865.701 1699.5 865.301 1698.7 864.801C1695.3 871.001 1691.9 880.001 1694.9 885.901C1699.9 896.001 1706.7 890.301 1711.7 895.701C1716.7 901.101 1714 907.801 1723.8 907.101C1726.4 906.901 1729.8 905.301 1733.1 902.501C1735.5 879.001 1714.5 872.501 1701.3 866.201Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.4 898.199C1692 895.399 1688.8 901.299 1694.1 900.799C1699.5 900.299 1702.3 896.199 1703.4 900.999C1704.4 905.899 1696.8 915.599 1686 913.899C1675.2 912.199 1678.7 901.099 1685.4 898.199Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1721.2 879.5C1721.2 879.5 1724.5 881.6 1725.4 882.9",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.41 885.102C1727.41 885.102 1729.51 888.002 1730.01 888.902",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.5 884.898C1723.5 884.898 1725.6 886.698 1726.2 887.798",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.1 891.801C1730.1 891.801 1730.7 893.401 1730.9 895.301",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.91 893.398C1727.91 893.398 1728.21 896.698 1728.21 897.498",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.9 908.898C1624.9 908.898 1634.2 924.698 1651.1 926.398",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.9 909L1621.5 932.3C1621.5 932.3 1614.1 928.6 1608.7 935.5C1608.7 935.5 1608.1 944.9 1623.9 951.2C1639.7 957.4 1668.6 927.5 1668.6 927.5",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.1 911C1642.1 911 1627.2 929.2 1621.5 932.4",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664 931C1664 931 1651 946.3 1643.6 947.6",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.9 928.398C1660.9 928.398 1658.7 931.398 1656.7 932.998",
    stroke: "#FF802C",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.7 928.301L1652.8 932.201",
    stroke: "#FF802C",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.1 923.801C1654.6 924.401 1650.3 928.801 1650.3 928.801",
    stroke: "#FF802C",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.4 936.699C1654.4 936.699 1650.2 939.899 1649.4 940.399",
    stroke: "#FF802C",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617 935.199C1617 935.199 1610.4 935.299 1609.1 938.999",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.6 940.5C1620.6 940.5 1615.3 940.8 1613.6 945.1",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.2 917.399C1740.5 914.499 1737.5 919.799 1734.4 916.799C1723.1 905.799 1717.1 906.599 1707.3 911.699L1701.9 914.499C1701.9 914.499 1701.7 936.299 1730.3 932.099C1730.3 932.099 1727.5 944.399 1741.3 945.399C1741.3 945.399 1754.2 925.399 1744.2 917.399Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.7 909.598C1727.7 909.598 1730.8 916.198 1736.7 917.798",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700.7 911.199C1700.7 911.199 1700.4 936.399 1730.3 932.099",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740.7 929.398C1740.7 929.398 1740.4 935.598 1745.7 937.198",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.9 934.5C1735.9 934.5 1736.9 942.1 1742.5 943.4",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1584.5 816.998C1584.5 816.998 1594.4 800.098 1607 803.998C1633.2 811.998 1623.4 862.298 1593.6 871.498C1556.2 883.098 1540.9 845.798 1550.9 834.198C1560.8 822.598 1577.1 827.698 1584.5 816.998Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.09 793.9C1625.79 792.2 1609.89 796.5 1600.29 804.2C1593.49 808.9 1589.19 815.1 1586.69 823C1584.39 829.2 1583.89 838.6 1583.89 838.6C1550.49 871 1595.89 903 1623.49 903.2L1644.89 903.4C1668.19 902.4 1692.59 891.3 1696.39 863.6L1696.89 863.8C1696.79 863.8 1712.99 798.4 1650.09 793.9Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.3 804.202C1593.5 808.902 1589.2 815.102 1586.7 823.002C1584.4 829.202 1583.9 838.602 1583.9 838.602C1582 840.402 1580.3 842.402 1578.9 844.202C1582 849.602 1588.6 852.802 1600 852.702C1645.3 852.102 1642.1 810.402 1639 793.602C1620.7 793.802 1608.3 797.802 1600.3 804.202Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614.5 812.999C1634.6 811.299 1635.3 853.399 1614.9 854.399C1595.5 855.299 1598.7 814.299 1614.5 812.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.6 817.598C1623 820.098 1619.9 847.398 1609.4 847.398C1597 847.398 1599.9 814.998 1611.6 817.598Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.2 814.602C1660.4 813.702 1665.1 817.202 1667.9 822.402C1674.2 834.202 1671.3 855.002 1657.1 856.602C1636.3 858.702 1637.4 816.902 1654.2 814.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.9 819.802C1662.7 821.702 1661.1 849.902 1650.3 850.402C1637.7 851.002 1638.7 817.802 1650.9 819.802Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.6 870.199C1637.9 874.099 1620.1 874.299 1618.9 861.199C1617.4 844.699 1629 841.399 1638.9 842.899C1649.9 844.399 1652.7 863.899 1643.6 870.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.4 842.201C1633.4 842.201 1617.4 841.601 1618.9 861.201",
    stroke: "#4E003D",
    strokeWidth: 1.28,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629 852.101C1629 852.101 1628.2 867.401 1633.5 868.301C1638.8 869.301 1639.7 853.301 1639.7 853.301C1639.7 853.301 1635.3 857.601 1634.5 850.301C1634.5 850.301 1633.4 859.801 1629 852.101Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.5 860.601C1630.9 861.301 1630.3 862.201 1629.8 863.001C1630.4 865.601 1631.6 867.901 1633.5 868.301C1636.9 868.901 1638.5 862.501 1639.3 857.801C1635.5 857.501 1633.1 858.801 1631.5 860.601Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629 852.101C1629 852.101 1628.2 867.401 1633.5 868.301C1638.8 869.301 1639.7 853.301 1639.7 853.301C1639.7 853.301 1635.3 857.601 1634.5 850.301C1634.5 850.301 1633.4 859.801 1629 852.101Z",
    stroke: "#4E003D",
    strokeWidth: 0.96,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664.29 806.001C1664.29 806.001 1661.69 800.601 1656.09 801.401C1651.09 802.101 1649.99 805.301 1649.99 805.301",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.09 804.699C1613.09 804.699 1615.79 799.299 1621.49 800.199C1626.39 800.999 1627.49 804.299 1627.49 804.299",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664.49 899.402C1710.89 883.002 1697.29 830.202 1697.29 830.202C1697.29 830.202 1695.59 822.202 1692.59 819.602",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.09 838.699C1585.09 838.699 1566.09 850.199 1574.59 872.599C1583.99 897.099 1617.89 902.699 1617.89 902.699C1617.89 902.699 1636.09 904.099 1644.09 900.899",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.2 864.901C1648.2 864.901 1663.1 834.501 1684.4 851.001L1648.2 864.901Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.09 850.499C1684.99 854.999 1677.69 872.999 1665.29 868.299C1653.09 863.499 1659.79 845.399 1673.09 850.499Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.59 864.799C1648.59 864.799 1663.89 832.299 1684.39 850.899",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.2 845.301C1594.8 845.301 1615.6 845.101 1617.5 865.901L1594.2 845.301Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.4 852.601C1605.5 852.401 1608.3 852.101 1611 851.601C1604.2 845.201 1594.5 845.301 1594.2 845.301L1602.4 852.601Z",
    fill: "#870D45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.2 845.301C1594.8 845.301 1615.6 845.101 1617.5 865.901",
    stroke: "#4E003D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607 851.302C1618 859.202 1606.2 874.802 1594.8 866.502C1583.5 858.202 1594.6 842.302 1607 851.302Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.29 841.301C1628.29 841.301 1639.79 840.201 1639.79 842.101C1639.79 844.001 1635.19 849.001 1632.09 848.301C1628.99 847.601 1623.79 841.301 1628.29 841.301Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.09 843.801C1642.09 843.801 1636.29 852.301 1642.69 867.301",
    stroke: "#4E003D",
    strokeWidth: 1.28,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.09 845.301C1627.09 845.301 1631.49 849.701 1625.99 862.501",
    stroke: "#4E003D",
    strokeWidth: 1.28,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712 817.899C1712 817.899 1690.6 793.999 1680.2 802.999C1663 817.899 1685.9 874.899 1718.6 875.599C1759.8 876.399 1764.4 834.199 1750.9 825.399C1737.5 816.699 1722.7 826.599 1712 817.899Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.59 850.5C1687.59 850.5 1692.59 857.5 1694.89 859.9",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1699.09 860.301C1699.09 860.301 1701.89 862.401 1704.09 864.501",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.3 866.199C1701.3 866.199 1705.2 869.599 1708.3 870.399",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.8 867.801C1710.8 867.801 1717.4 869.901 1719.3 870.401",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714.09 873C1714.09 873 1719.29 874 1721.59 873.7",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.9 871.8C1731.9 871.8 1735.2 871.1 1737.5 870",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.7 829.398C1751.7 829.398 1754.3 834.398 1754.3 839.498",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.19 840.602C1752.19 840.602 1752.69 842.702 1751.99 846.702",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.49 850.898C1747.49 850.898 1745.19 856.998 1744.49 858.398",
    stroke: "#870D45",
    strokeWidth: 1.28,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_36506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage23);
export default __webpack_public_path__ + "static/media/image23.5b7402bf8f11f2f4c2734e087eae0bec.svg";
export { ForwardRef as ReactComponent };